import { markRaw } from "vue";
import model from "../model";
import type { ClientConfigData, DeferredClientConfigKey } from "../types/client-config-types";
import { addQueryParams, getQueryParam, removeArrayItem } from "../utils/utils";
import { getScript } from "@/ts/utils/model-utils";
import type { EventName } from "../types/main-model";

const loadedDeferredConfigs: DeferredClientConfigKey[] = [];

export default {
    init(){
        let configs = markRaw<ClientConfigData>({});
        for(let i = window.clientConfig.length - 1; i >= 0; i--){
            let config = window.clientConfig[i];
            if(typeof config !== 'function') continue;

            Object.assign(configs, config(getQueryParam));
            removeArrayItem(config, window.clientConfig);
        }
        model.clientConfig = configs;
        registerExtraEvents();
    },
}

export async function loadDeferredClientConfig(propName: DeferredClientConfigKey, global?: boolean){
    if(loadedDeferredConfigs.includes(propName)) return;

    let deferred = model.clientConfig.deferred;
    if(!deferred) return;

    await getScript(addQueryParams(deferred[propName], {c: Date.now() + ''}), global);

    let config = window.clientConfig[0];
    removeArrayItem(config, window.clientConfig);
    if(typeof config !== 'function') return;

    Object.assign(model.clientConfig, config());
    loadedDeferredConfigs.push(propName);
}

function registerExtraEvents(){
    const extraEvents = model.clientConfig.extraEvents || {};
    Object.keys(extraEvents).forEach(evtName => {
        const callback = extraEvents[evtName as EventName];
        if(!callback) return;
        
        model.on(evtName as EventName, callback);
    });
}